    $(document).ready(function(){
        // alert("testing");
      $(window).scroll(function(){
          if ($(this).scrollTop() > 50) {
             $('#shopify-section-header').addClass('newClass');
          } else {
             $('#shopify-section-header').removeClass('newClass');
          }
      });
        });